import { useSelector } from 'react-redux';
import { ApplicationState } from '../../rootStore';
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from '@/main/services/reducerUtils';
import { SubModelState } from './subModelTypes';

export const useSubModelReducer = (keyReducer: string = 'default') => {
  const returnSelector = useSelector(
    (state: ApplicationState) => state.subModel
  );
  if (keyReducer === 'default')
    return returnSelector as IReducerWithIsolated<SubModelState>;

  const updateState = {
    ...returnSelector,
    isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA
  };

  return updateState as IReducerWithIsolated<SubModelState>;
};

